import { ReactNode } from "react";

import { Box } from "@mantine/core";

import { SideMenu } from "../menu/SideMenu.tsx";

interface Props {
  children: ReactNode;
}

export function Layout({ children }: Readonly<Props>) {
  return (
    <Box style={{ display: "flex" }}>
      <SideMenu />
      <Box ml={300} mr={50} my={50} style={{ flex: 1 }}>
        {children}
      </Box>
    </Box>
  );
}
